import * as validators from './validatorTypes';
import type Validator from '../models/Validator';

export enum ValidationType {
  AlphaOnlyValidator = 'AlphaOnlyValidator',
  AlphaNumericValidator = 'AlphaNumericValidator',
  BooleanValidator = 'BooleanValidator',
  CurrencyValidator = 'CurrencyValidator',
  EmailValidator = 'EmailValidator',
  NameValidator = 'NameValidator',
  PhoneValidator = 'PhoneValidator',
  PositiveIntegerValidator = 'PositiveIntegerValidator',
  PropertyAddressValidator = 'PropertyAddressValidator',
  TermsStartDateValidator = 'TermsStartDateValidator',
  TermsStartDateExtendedRangeValidator = 'TermsStartDateExtendedRangeValidator',
  TermsEndDateValidator = 'TermsEndDateValidator',
  ZeroCurrencyValidator = 'ZeroCurrencyValidator',
}

export default {
  getValidator: (validatorType: ValidationType): Validator => {
    return validators[validatorType];
  },
};
